module.exports = __webpack_public_path__ + "static/media/PLAYER1.26e6efdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/PLAYER1.png
// module id = 265
// module chunks = 0